<template>
  <div class="froala-editor-component">
    <froala
      id="froala-editor"
      :config="config"
      :tag="'textarea'"
      v-model="currentContent"
    >
    </froala>
  </div>
</template>
<script>
export default {
  name: "FroalaEditor",
  props: {
    content: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      currentContent: "",
      currentImage: null,
      config: {
        enter: 1,
        paragraphFormatSelection: true,
        heightMin: 250,
        heightMax: 600,
        charCounterCount: false,
        quickInsertEnabled: false,
        emoticonsUseImage: false,
        key:
          "iTB2xB2B1A4C1B3C1wd1DBKSPF1WKTUCQOa1OURPJ1KDe2F-11D2C2D2G2C3B3D2D6D1F1==",
        imageUploadURL: null,
        events: {
          "image.beforeUpload": event => {
            this.currentImage = event[0];
          },
          "image.inserted": event => {
            let reader = new FileReader();
            reader.readAsDataURL(this.currentImage);
            reader.onloadend = function() {
              event[0].src = reader.result;
            };
          },
          "table.inserted": function(table) {
            table.style.border = "1px solid rgb(24, 24, 24)";
            table.style.borderCollapse = "collapse";
            let allTd = table.querySelectorAll("td");
            for (let element of allTd) {
              element.style.border = "1px solid rgb(24, 24, 24)";
            }
          }
        },
        imageInsertButtons: ["imageUpload", "|", "imageByURL"],
        toolbarButtons: {
          moreText: {
            buttons: [
              "bold",
              "italic",
              "underline",
              "strikeThrough",
              "subscript",
              "superscript",
              "fontFamily",
              "fontSize",
              "textColor",
              "backgroundColor",
              "inlineClass",
              "inlineStyle",
              "clearFormatting"
            ],
            align: "left",
            buttonsVisible: 3
          },
          moreParagraph: {
            buttons: [
              "lineHeight",
              "alignLeft",
              "alignCenter",
              "formatOLSimple",
              "paragraphFormat",
              "alignRight",
              "alignJustify",
              "formatOL",
              "formatUL",
              "paragraphStyle",
              "outdent",
              "indent",
              "quote"
            ],
            align: "left",
            buttonsVisible: 5
          },
          moreRich: {
            buttons: [
              "insertImage",
              "insertTable",
              "emoticons",
              "fontAwesome",
              "specialCharacters",
              "embedly",
              "insertHR"
            ],
            align: "left",
            buttonsVisible: 5
          },
          moreMisc: {
            buttons: [
              "undo",
              "redo",
              "fullscreen",
              "print",
              "spellChecker",
              "selectAll",
              "html"
            ],
            align: "right",
            buttonsVisible: 2
          }
        }
      }
    };
  },
  watch: {
    currentContent() {
      this.$emit("input", this.currentContent); 
    },
    content() {
      this.currentContent = this.content;
    }
  },
  created() {
    this.currentContent = this.content;
  },
  beforeDestroy() {
    this.currentContent = "";
  }
};
</script>
<style lang="scss" scoped>
.froala-editor-component {
  width: 100%;
}
::v-deep {
  & .fr-box.fr-basic .fr-wrapper,
  .fr-toolbar.fr-top {
    border: none;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }
  & .fr-second-toolbar {
    display: none;
  }
  & .fr-toolbar .fr-command.fr-btn svg.fr-svg,
  .fr-popup .fr-command.fr-btn svg.fr-svg,
  .fr-modal .fr-command.fr-btn svg.fr-svg {
    height: 17px;
  }
  & .fr-toolbar .fr-command.fr-btn i,
  .fr-toolbar .fr-command.fr-btn svg,
  .fr-popup .fr-command.fr-btn i,
  .fr-popup .fr-command.fr-btn svg,
  .fr-modal .fr-command.fr-btn i,
  .fr-modal .fr-command.fr-btn svg {
    display: block;
    text-align: center;
    float: none;
    margin: 3px 2px;
    width: 17px;
  }
}
::v-deep .fr-toolbar .fr-command.fr-btn {
  z-index: 0;
}
::v-deep .fr-element {
  z-index: 0;
}
::v-deep .fr-wrapper {
  z-index: 0;
}
::v-deep .fr-wrapper.show-placeholder .fr-placeholder {
  z-index: -1;
}
</style>
